import "./Login.scss";
import whoBannerBG from "./../../assets/images/Doctor-helping-Patient.jpg";
import { getSsoUrl } from "../../services/auth.service";
import AuiButton from "../../components/Buttons/Buttons";

const Login = () => {
  const handleLogin = async () => {
    try {
      const ssoUrl = await getSsoUrl();
      window.open(ssoUrl, "_self");
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <main className="container login-page p-0">
      <div className="my-md-5">
        <aui-banner
          alt="Login Banner of doctor helping patient"
          type="primary"
          image={whoBannerBG}
        >
          <h1 className="mb-4 font-400 aui-banner-desc">
            Welcome to the BEC Training. Please sign in / sign up to manage your
            organization's Basic Emergency Care courses information or submit a
            course request.
          </h1>
          <div className="btn-submit-login">
            <AuiButton
              variant="primary"
              buttontitle="Log In | Sign Up"
              modalid="exampleModal"
              size="medium"
              type="submit"
              aria-placeholder="Sign In | Sign Up button"
              buttonClick={handleLogin}
              data-testid="login-button"
              buttonid="loginBtn"
            ></AuiButton>
          </div>
        </aui-banner>
      </div>
    </main>
  );
};

export default Login;
